import(/* webpackMode: "eager" */ "/vercel/path0/src/app/for_you/follow_up/page.tsx");
